import { api } from "../api/api";
import { AuthMeResponse, LoginResponse } from "../models/auth/auth.response";
import { ApiResponse } from "../models/base/ApiResponse";
import { ForgotPasswordRequestDTO, ResetPasswordRequestDTO } from "../models/auth/auth.request";


export const authService = {
    async login(email: string, password: string): Promise<ApiResponse<LoginResponse>> {
        const { data } = await api.post<ApiResponse<LoginResponse>>("/auth/login", { email, password });
        return data;
    },

    async logout(): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>("/auth/logout");
        return data;
    },

    async authMe(): Promise<ApiResponse<AuthMeResponse>> {
        const { data } = await api.get<ApiResponse<AuthMeResponse>>("/auth/me");
        return data;
    },

    async forgotPassword(dto: ForgotPasswordRequestDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>("/auth/forgot-password", dto);
        return data;
    },

    async resetPassword(dto: ResetPasswordRequestDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>("/auth/reset-password", dto);
        return data;
    },

    async EmailExists(email: string): Promise<ApiResponse<boolean>> {
        const { data } = await api.get<ApiResponse<boolean>>("/auth/email-exists", {
            params: {
                email: email
            }
        });
        return data;
    },

    async verifyEmailToken(token: string): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>("/auth/verify-email", { token });
        return data;
    }

}